import React from 'react';
import PropTypes from 'prop-types';
import Content from './Content';

export default function CreateEditTagGroupModal(props) {
	const {engagementId, labels, showModal, setShowModal, onClose, theme, errorComponent, isEditModal} = props;

	return (
		<Content
			isEditModal={isEditModal}
			showModal={showModal}
			setShowModal={setShowModal}
			labels={labels}
			engagementId={engagementId}
			onClose={onClose}
			theme={theme}
			errorComponent={errorComponent}
			{...props}
		/>
	);
}

CreateEditTagGroupModal.propTypes = {
	engagementId: PropTypes.number, // The ID of the engagement
	showModal: PropTypes.bool, // Flag to determine if the modal should be shown or not
	setShowModal: PropTypes.func, // Function to set the show modal flag
	errorComponent: PropTypes.func,
	labels: PropTypes.shape({
		createModalTitle: PropTypes.string, // The title for the create modal
		createModalDescription: PropTypes.string, // Description for the create modal
		editModalDescription: PropTypes.string, // Description for the edit modal
		close: PropTypes.string, // Label for the close button
		cancel: PropTypes.string, // Label for the cancel button
		save: PropTypes.string, // Label for the save button
		saveAndCloseLabel: PropTypes.string, // Label for the save and close button of the modal
		saveAndCreateLabel: PropTypes.string, // Label for the save and create another button of the modal
		tagGroupNameLabel: PropTypes.string, // Label for the Tag group name input field
		required: PropTypes.string // Error message for the Tag group name input field
	})
};

CreateEditTagGroupModal.defaultProps = {
	engagementId: null,
	showModal: false,
	setShowModal: () => {},
	labels: {
		createModalTitle: 'New sample tag group',
		editModalTitle: 'Edit sample tag group',
		createModalDescription: `Enter tag group details below and select <b>\'Save and close\'</b> to finish. To create another tag group, select <b>\'Save and create another\'</b>.`,
		editModalDescription: `Edit the tag group details below and select '<b>{0}</b>' to finish.`,
		close: 'Close',
		cancel: 'Cancel',
		save: 'Save',
		saveAndCloseLabel: 'Save and close',
		saveAndCreateLabel: 'Save and create another',
		tagGroupNameLabel: 'Tag group name (required)',
		required: 'Required'
	}
};
